/* eslint-disable @typescript-eslint/no-explicit-any */

import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { commonLocales } from "src/locales/commonLocales";

import { CONSTANTS } from "../../constants";
import commonUtils from "../../utils/common.utils";

function handleResponse(
  res: any,
  navigate?: any,
  toast: boolean = true,
  conflictHandle: boolean = false,
  redirectTo: string = "/"
) {
  if (!res.ok) {
    if (
      toast &&
      conflictHandle &&
      res.status === CONSTANTS.HTTP_STATUS.CONFLICT
    ) {
      commonUtils.toastService(
        res?.data
          ? commonUtils.flattenObjectToString(res?.data)
          : CONSTANTS.HTTP_STATUS.ERROR,
        CONSTANTS.HTTP_STATUS.ERROR
      );
    }
    if (
      res.status === CONSTANTS.HTTP_STATUS.NOT_FOUND ||
      res.status === CONSTANTS.HTTP_STATUS.INTERNAL_SERVER_ERROR ||
      res.status === CONSTANTS.HTTP_STATUS.INVALID_DATA
    ) {
      if (toast) {
        commonUtils.toastService(
          res?.data
            ? commonUtils.flattenObjectToString(res?.data)
            : CONSTANTS.HTTP_STATUS.ERROR,
          CONSTANTS.HTTP_STATUS.ERROR
        );
      }
    } else if (res.status === CONSTANTS.HTTP_STATUS.FORBIDDEN) {
      window.location.href = redirectTo;
    } else if (res.status === CONSTANTS.HTTP_STATUS.UNAUTHORIZED) {
      if (localStorage?.getItem("ACCESS_TOKEN")) {
        localStorage.clear();
        commonUtils.toastService(
          res?.data.message
            ? commonLocales.expiry
            : CONSTANTS.HTTP_STATUS.ERROR,
          CONSTANTS.HTTP_STATUS.ERROR
        );

        setTimeout(() => {
          navigate?.push(redirectTo);
          window.location.href = redirectTo;
        }, COMMON_CONSTANTS.RESPONSE_TIME_OUT);
      }
    } else if (res.status === CONSTANTS.HTTP_STATUS.BAD_REQUEST) {
      if (toast) {
        commonUtils.toastService(
          res?.data.message,
          CONSTANTS.HTTP_STATUS.ERROR
        );
      }
      return res;
    } else if (res.status === CONSTANTS.HTTP_STATUS.CONFLICT) {
      return res;
    } else {
      if (toast) {
        commonUtils.toastService(
          CONSTANTS.HTTP_STATUS.ERROR,
          CONSTANTS.HTTP_STATUS.ERROR
        );
      }

      return res;
    }
  }

  return res;
}

export default handleResponse;
